/* tslint:disable */
/* eslint-disable */
/**
 * Pull Guardian AzDO Lookup
 * Read-only lookups used by the PrDispatch UI to let users pick a project, repository, and branch without typing a repo URL. The `projectId` path parameter is a stable slug validated against `pullguardian.prdispatch.projects`; unknown ids return 404. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AzdoBranch {
    /**
     * Branch short name (e.g. `main`).
     */
    'name': string;
    /**
     * True when the branch is the repository default.
     */
    'isDefault'?: boolean;
}
export interface AzdoRepository {
    /**
     * AzDO repository GUID.
     */
    'id': string;
    'name': string;
    /**
     * Clone/web URL used as the `repoUrl` field in the subsequent prdispatch submit call. 
     */
    'webUrl': string;
}

/**
 * AzdoLookupApi - axios parameter creator
 */
export const AzdoLookupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjectRepositories: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('listProjectRepositories', 'projectId', projectId)
            const localVarPath = `/api/azdo/projects/{projectId}/repositories`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} repositoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRepositoryBranches: async (projectId: string, repositoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('listRepositoryBranches', 'projectId', projectId)
            // verify required parameter 'repositoryId' is not null or undefined
            assertParamExists('listRepositoryBranches', 'repositoryId', repositoryId)
            const localVarPath = `/api/azdo/projects/{projectId}/repositories/{repositoryId}/branches`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"repositoryId"}}`, encodeURIComponent(String(repositoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AzdoLookupApi - functional programming interface
 */
export const AzdoLookupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AzdoLookupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProjectRepositories(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzdoRepository>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProjectRepositories(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AzdoLookupApi.listProjectRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} repositoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRepositoryBranches(projectId: string, repositoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzdoBranch>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRepositoryBranches(projectId, repositoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AzdoLookupApi.listRepositoryBranches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AzdoLookupApi - factory interface
 */
export const AzdoLookupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AzdoLookupApiFp(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjectRepositories(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AzdoRepository>> {
            return localVarFp.listProjectRepositories(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} repositoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRepositoryBranches(projectId: string, repositoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AzdoBranch>> {
            return localVarFp.listRepositoryBranches(projectId, repositoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AzdoLookupApi - object-oriented interface
 */
export class AzdoLookupApi extends BaseAPI {
    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listProjectRepositories(projectId: string, options?: RawAxiosRequestConfig) {
        return AzdoLookupApiFp(this.configuration).listProjectRepositories(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {string} repositoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listRepositoryBranches(projectId: string, repositoryId: string, options?: RawAxiosRequestConfig) {
        return AzdoLookupApiFp(this.configuration).listRepositoryBranches(projectId, repositoryId, options).then((request) => request(this.axios, this.basePath));
    }
}



